import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleFields", "inlineFields"]

  connect() {
    this.updateFields()
  }

  updateFields(event) {
    const selectedMode = this.element.querySelector('input[name="site[widget_mode]"]:checked')?.value

    if (!this.hasToggleFieldsTarget || !this.hasInlineFieldsTarget) {
      return
    }

    if (selectedMode === "inline") {
      this.toggleFieldsTarget.classList.add("hidden")
      this.inlineFieldsTarget.classList.remove("hidden")
    } else {
      this.toggleFieldsTarget.classList.remove("hidden")
      this.inlineFieldsTarget.classList.add("hidden")
    }
  }
}
